import {
    Sheet,
    SheetContent,
    SheetDescription,
    SheetFooter,
    SheetHeader,
    SheetTitle,
    SheetTrigger
} from "@/components/ui/sheet";
import {Button} from "@/components/ui/button";

export default function CWFSheet({ children,onOpenChange,open,trigger,title,footer,className,description, ...props }) {
    return(
        <Sheet {...props} onOpenChange={onOpenChange} open={open}>
            {trigger!==null &&(
                <SheetTrigger asChild>
                    {trigger}
                </SheetTrigger>
            )}
            <SheetContent className={className}>
                <SheetHeader>
                    {title && <SheetTitle>{title}</SheetTitle>}
                    {description && <SheetDescription>{description}</SheetDescription>}
                </SheetHeader>
                {children}
                {footer!==null && (
                    <SheetFooter>
                        {footer}
                    </SheetFooter>
                )}
            </SheetContent>

        </Sheet>
    )
}